// extracted by mini-css-extract-plugin
module.exports = {"section_top_rank":"study_top_rank_two_section_top_rank__6lRTq","wrapper":"study_top_rank_two_wrapper__SSgAB","title_wrapper":"study_top_rank_two_title_wrapper__Sej_H"};